import React from 'react';
import { withPrefix, Link } from 'gatsby';

const Partners = (props) => {
  return (
    <section className="partners">
      <div className="special-bg-container">
        <div className="container">
          <div className="columns special-bg">
            <div className="column is-full logos">
              <div className="columns lower">
                <div className="column is-3 logo"><img src={withPrefix('/img/aws_tinted.svg')} alt="Logo" /></div>
                <div className="column is-3 logo"><img src={withPrefix('/img/mac_tinted.svg')} alt="Logo" /></div>
                <div className="column is-3 logo"><img src={withPrefix('/img/impact_tinted.svg')} alt="Logo" /></div>
                <div className="column is-3 logo"><img style={{ marginTop: 12 }} src={withPrefix('/img/fido.svg')} alt="Logo" /></div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <Link to={ props.locale === "en" ? "/contact" : "/de/contact" } className="button is-rounded customers-button">{ props.partners.partnersButton }</Link>
    </section>
  );
};

export default Partners;
